import script from "./TopMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./TopMenu.vue?vue&type=script&setup=true&lang=ts"

import "./TopMenu.vue?vue&type=style&index=0&id=f991ccb2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f991ccb2"]])

export default __exports__